<template>
	<DialogFormDialog ref="dialog" :strings="strings" @reset="reset">
		<ha-form-wizard ref="wizard" :type="wizardType"></ha-form-wizard>
		<!-- <Wizard :is="wizardType" ref="wizard" :form.sync="values" /> -->
	</DialogFormDialog>
</template>

<script>
import strings from "@/utils/strings";

export default {
	data() {
		return {
			wizardType: "",
		};
	},

	computed: {
		strings() {
			return strings.live.scenes[`${this.wizardType}WizardDialog`] || {};
		},
	},

	mounted() {
		// Wrap parent pop method to capture *current* value as a placeholder.
		this.pop = (type) => {
			this.wizardType = type;
			return this.$refs.dialog.pop(() => this.$refs.wizard.saveScene());
		};
	},

	methods: {
		reset() {
			this.$refs.wizard.reset();
		},
	},
};
</script>
